/* eslint-disable @typescript-eslint/no-unused-vars */
import { Matrix, Quaternion, Vector3 } from "babylonjs";

export default class PoseBase {

  protected position = new Vector3(0, 0, 0);
  protected rotation = Quaternion.Identity();
  protected scale = new Vector3(1, 1, 1);

  constructor() {
    //
  }

  public setMatrix(matrix:Matrix) { matrix.decompose(this.scale, this.rotation, this.position); }
  public getMatrix():Matrix { return Matrix.Compose(this.scale, this.rotation, this.position); }
  public getMatrixToRef(matrix:Matrix):Matrix { return Matrix.ComposeToRef(this.scale, this.rotation, this.position, matrix); }

  public getPosition():Vector3 { return this.position.clone(); }
  public getPositionToRef(position:Vector3):Vector3 { return position.copyFrom(this.position); }

  public getRotation():Quaternion { return this.rotation.clone(); }
  public getRotationToRef(rotation:Quaternion):Quaternion { return rotation.copyFrom(this.rotation); }

  public getScale():Vector3 { return this.scale.clone(); }
  public getScaleToRef(scale:Vector3):Vector3 { return scale.copyFrom(this.scale); }

  public update(_timeDelta?:number) { /* override */ }

  public reset() {
    this.position.set(0, 0, 0);
    this.rotation.set(0, 0, 0, 1);
    this.scale.set(1, 1, 1);
  }
}